export default __webpack_public_path__ + "static/media/cambiando_paradigmas_en_los camiones_scania.732a90a1.pdf";